/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Importar useNavigate
import { useAuth } from '../context/AuthContext';
import { API_BASE } from '../config';
import '../styles/informacion.css'; // Asegúrate de importar tu CSS

const Informacion = () => {
  const { token } = useAuth(); // Obtener el token desde el contexto de autenticación
  const { po_number, sku_code, cart_code, formattedLocation } = useParams(); // Extraer parámetros de la URL
  const [item, setItem] = useState(null); // Estado para almacenar la información del ítem
  const [loading, setLoading] = useState(true); // Estado para controlar la carga
  const navigate = useNavigate(); // Inicializar useNavigate

  useEffect(() => {
    const fetchItemData = async () => {
      if (!token) {
        console.error('No token available');
        return;
      }

      try {
        // Obtener sólo el PO necesario. Antes se llamaba a get-all-po, que traía
        // TODO el catálogo de pedidos activos (~5s / 130KB) sólo para leer un ítem.
        const response = await fetch(`${API_BASE}/get-po/?po_number=${encodeURIComponent(po_number)}`, {
          method: 'GET',
          headers: {
            'Authorization': `Token ${token}`,
          },
        });

        if (response.ok) {
          const matchedPo = await response.json();
          console.log('PO Data:', matchedPo);

          // Buscar el ítem que coincide con sku_code dentro del PO
          const foundItem = (matchedPo.items || []).find(item => item.sku_code === sku_code);
          if (foundItem) {
            setItem(foundItem); // Establecer el ítem encontrado
            console.log('Item encontrado:', foundItem);
          } else {
            console.error(`No se encontró el item con el SKU: ${sku_code}`);
          }
        } else {
          console.error('Failed to fetch PO data', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false); // Cambiar estado de carga a false
      }
    };

    fetchItemData();
  }, [token, po_number, sku_code]); // Dependencias de useEffect

  // Muestra un mensaje de carga mientras se obtienen los datos
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }
  

  // Si no se encuentra el ítem, muestra un mensaje
  if (!item) {
    return <div>No se encontró información del ítem.</div>;
  }

  // Función para manejar la navegación
  const handleNavigate = () => {
    navigate(`/picker/${po_number}/${cart_code}/${sku_code}/${formattedLocation}`);
  };

  // Función para manejar la navegación hacia atrás
  const handleBack = () => {
    navigate(`/picker/${po_number}/${cart_code}/${sku_code}`);
  };

  // Renderiza la información del ítem
  return (
    <div className="item-info-container">
      {/* Botón de retroceso */}
      <span className="back-button" onClick={handleBack}>&larr;</span>

      <h1>Información del Ítem</h1>
      <p>Pesa {item.ordered_quantity} kg en {item.format_name}</p>
      <p>de {item.format_quantity} kg</p>
      <p>de {item.sku_name}</p>
      <p>Sku: {item.sku_code}</p>
      <br />
      {/* Botón para navegar */}
      <button className="listo-button" onClick={handleNavigate}>Listo</button>
    </div>
  );
};

export default Informacion;
